var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.8,
    height: 8,
    viewBox: "0 0 12.8 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#43425d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.5,15.3H6.1V13.7H4.5Zm0,3.2H6.1V16.9H4.5Zm0-6.4H6.1V10.5H4.5Zm3.2,3.2h9.6V13.7H7.7Zm0,3.2h9.6V16.9H7.7Zm0-8v1.6h9.6V10.5Z",
    transform: "translate(-4.5 -10.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialList);
export default __webpack_public_path__ + "static/media/material-list.47f460da83e521744be5ac1099c6f0f8.svg";
export { ForwardRef as ReactComponent };